import { render, staticRenderFns } from "./wigs-details-print-page-client-cell.vue?vue&type=template&id=993a0a2c"
import script from "./wigs-details-print-page-client-cell.vue?vue&type=script&lang=js"
export * from "./wigs-details-print-page-client-cell.vue?vue&type=script&lang=js"
import style0 from "./wigs-details-print-page-client-cell.vue?vue&type=style&index=0&id=993a0a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports